import React, { useState } from "react";
import { Button, Form, Select } from "antd";
import FilterLayout from "../../../components/FilterLayout/FilterLayout";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";
import { useHistory } from "react-router-dom";

const { Option } = Select;
const BuyProductReportFilter = ({
  getBuyProductReport,
  form,
  setSearch,
  exportNotifications,
}) => {
  const history = useHistory();

  const [isVisible, setIsVisible] = useState(false);

  return (
    <FilterLayout
      onSearch={getBuyProductReport}
      setSearch={null}
      isVisible={isVisible}
      setIsVisible={setIsVisible}
      reportFilter={exportNotifications}
      placeHolder={"Search Notifications"}
      disabledFilter
    >
      <Form
        form={form}
        name="sellReportForm"
        onFinish={() => {
          setIsVisible(false);
        }}
        requiredMark={false}
        scrollToFirstError
      >
        <FormWrapper>
          <Select
            className="border-black-8 input-size mb-10"
            // onChange={(value) => onChangeFilters({ capacity_unit: value })}
            placeholder="پلاک خودرو"
            value={null}
          >
            <Option value={null}>پلاک خودرو</Option>
            {/* {cars?.extra &&
                            cars.extra.capacity_unit.map((capacity_unit) => {
                                return (
                                    <Option key={capacity_unit[0]} value={capacity_unit[0]}>
                                        {capacity_unit[1]}
                                    </Option>
                                );
                            })} */}
          </Select>
          <div />
          <Button
            className="button-secondary input-size mb-10 sm:w-100"
            htmlType="submit"
          >
            فیلتر
          </Button>

          <Button
            className="button-red input-size sm:w-100 "
            onClick={() => {
              history.push(window.location.pathname);
              setSearch("");
              setIsVisible(false);
              setTimeout(() => {
                form.resetFields();
                form.submit();
              }, 100);
            }}
          >
            لغو فیلتر ها
          </Button>
        </FormWrapper>
      </Form>
    </FilterLayout>
  );
};

export default BuyProductReportFilter;
